import React from "react";
import { useUrl } from "@/context/SiteContext";
import ServicePage from "./ServicePage";

export default function ImprimareFibraCarbonPage() {
  const url = useUrl();
  return (
    <ServicePage
      backLabel="Tehnologii imprimare 3D"
      backTo={url.dept("tehnologii-imprimare-3d")}
      number="02"
      eyebrow="Tehnologie CFR · Markforged"
      title={["Fibră de carbon", "și alte fibre."]}
      tagline="Un nou mod de a produce piese cu rezistența aluminiului — Continuous Fiber Reinforcement pe imprimanta Markforged Mark Two."
      intro={[
        "O imprimantă 3D profesională, premiată pentru materialul compozit din fibră de carbon pe care îl folosește — creat în jurul procesului Continuous Fiber Reinforcement (CFR) — pentru a produce piese rezistente în mod fiabil.",
        "Cadru unibody din aluminiu asigură precizie ridicată și repetabilitate. Sistem întărit de extrudare permite imprimarea fiabilă a Onyx™ (filament de nylon umplut cu microfibre de carbon) pe parcursul a mii de ore.",
        "Mark Two este ușor de operat și întreținut — componente ușor accesibile, pat de imprimare detașabil cu repetabilitate de 10 μm. Pe lângă caracteristicile FFF, dispune de un sistem de întărire cu fibră de a doua generație care permite integrarea fibrelor continue în piese, obținând rezistență la fel de mare ca aluminiul prelucrat mecanic.",
      ]}
      bullets={[
        "Piese auto & echipamente industriale.",
        "Geometrii 3D complexe la cost redus.",
        "Brațe robotice & dispozitive de inspecție.",
        "Matrițe, puncții, unelte de formare.",
        "Piese rezistente la coroziune și uzură.",
        "Componente destinate utilizării finale.",
      ]}
      servicesEyebrow="Materiale compozite"
      servicesTitle="8 fibre și baze pentru orice cerință."
      services={[
        {
          title: "Fibră de carbon (continuă)",
          tags: "Rezistență la încovoiere: 200 MPa · aplicații industriale.",
          desc: "Fibra continuă de nivel inițial. De 10 ori mai rezistentă decât ABS când este așezată într-o bază compozită Onyx — potrivită pentru piese și componente industriale.",
        },
        {
          title: "Fibră de sticlă (continuă)",
          tags: "Alternativă accesibilă · x2.5 mai puternică decât Onyx · unelte robuste.",
          desc: "Nivelul de bază pentru fibre continue — rezistență ridicată la preț accesibil. De două ori și jumătate mai puternică și de opt ori mai rigidă decât Onyx. Produce unelte puternice și robuste.",
        },
        {
          title: "Fibră aramidică (Kevlar®)",
          tags: "Rezistență la impact: 240 MPa · durabilitate extremă.",
          desc: "Fibră continuă specializată bazată pe Dupont™ Kevlar® — absoarbe foarte bine energia, are durabilitate extremă. Piese rezistente la impact, aproape imposibil de distrus, potrivite pentru medii solicitante și manevre repetitive.",
        },
        {
          title: "Fibră de sticlă HSHT",
          tags: "Rezistență la încovoiere: 420 MPa · temperaturi înalte.",
          desc: "High Strength High Temperature — rezistență aproape egală cu Aluminiul 6061-T6 și toleranță mare la căldură. De 5× mai puternică și de 7× mai rigidă decât Onyx. Pentru matrițe, autoclave și piese în medii cu temperaturi înalte.",
        },
        {
          title: "Onyx™",
          tags: "Bază compozită principală · rezistență la încovoiere: 71 MPa.",
          desc: "Nylon umplut cu fibră de carbon micro — produce piese precise cu finisaj de suprafață aproape impecabil. Rezistență înaltă, tenacitate și rezistență chimică imprimat singur; poate fi întărit cu fibre continue pentru rezistența aluminiului.",
        },
        {
          title: "Nylon",
          tags: "Termoplastic neted · rezistență la încovoiere: 50 MPa · vopsibil.",
          desc: "Termoplastic non-abraziv, excelent pentru suprafețe ergonomice și susținerea lucrărilor pentru piese care sunt ușor de deteriorat. Poate fi vopsit sau colorat.",
        },
        {
          title: "Smooth TPU 95A",
          tags: "Asemănător cauciucului · flexibil · absorbant la impact.",
          desc: "Material flexibil pentru piese la cerere care absorb impactul. Rezolvă problema producției de piese flexibile în volume mici — fără costuri inițiale mari și termene lungi pentru unelte tradiționale.",
        },
        {
          title: "Precise PLA",
          tags: "Plastic ușor de imprimat · modelare concepte · accesibil.",
          desc: "PLA pentru modelarea și validarea de concepte precise. Se imprimă fără să se deformeze, disponibil în varietate de culori — accesibil ca preț pentru ajustarea fin a designurilor înainte de implementare.",
        },
      ]}
      stepsEyebrow="Beneficii CFR"
      stepsTitle="De ce CFR și nu fabricație convențională."
      steps={[
        {
          title: "Fibre continue integrate",
          desc: "Două sisteme de extrudare — unul pentru filament FFF, altul pentru șuvițe lungi de fibre continue. Rezultatul: piese de până la 10× mai rezistente decât orice material FFF, care înlocuiesc piesele din aluminiu.",
        },
        {
          title: "Geometrii complexe, cost redus",
          desc: "Imprimantele 3D excelează la geometrii complexe. Pentru piesele 3D cu rezistență, doar CFR se aliniază la rezistența metalului — la o fracțiune din costul unei matrițe CNC.",
        },
        {
          title: "Siguranța fibrei de carbon",
          desc: "Piese rigide, puternice, extrem de durabile, capabile să înlocuiască aluminiul prelucrat mecanic — fără riscurile fabricației cu fibră de carbon tradițională.",
        },
        {
          title: "Personalizare rapidă",
          desc: "Simpla tranziție de la modelul CAD la piesă permite modificări dinamice și rapide. Piese unicat, personalizate — fără constrângerile fabricației tradiționale.",
        },
      ]}
    />
  );
}
